module.exports = __webpack_public_path__ + "img/logo-header.a273b1d1.png";